import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../Modules/Shared/Services/api.service';
import { HttpResourceRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../../../environments/endpoints';
import { AcceptedResponse, NoContentResponse } from '../../Modules/Shared/Interfaces/response.interface';
import { AutopilotDevicesIndexResponse, AutopilotImportHistoryResponse } from '../../Interfaces/api/Intune/autopilot-devices.interface';

@Injectable({
    providedIn: 'root',
})
export class AutopilotDevicesService {
    private _apiService = inject(ApiService);

    index(skipLoading = true): HttpResourceRequest {
        return this._apiService.get<AutopilotDevicesIndexResponse>(
            endpoints.api.intune.autopilotDevices.index,
            { skipLoading }
        );
    }

    import(file: File, skipLoading = false): Observable<AcceptedResponse> {
        const formData = new FormData();
        formData.append('file', file);

        const request = this._apiService.post<AcceptedResponse>(
            endpoints.api.intune.autopilotDevices.import,
            { body: formData, skipLoading }
        );
        return this._apiService.run<AcceptedResponse>(request);
    }

    importHistoryRequest(skipLoading = true): HttpResourceRequest {
        return this._apiService.get<AutopilotImportHistoryResponse>(
            endpoints.api.intune.autopilotDevices.importHistory,
            { skipLoading }
        );
    }

    importHistory(skipLoading = true): Observable<AutopilotImportHistoryResponse> {
        return this._apiService.run<AutopilotImportHistoryResponse>(
            this.importHistoryRequest(skipLoading)
        );
    }

    delete(id: string): Observable<NoContentResponse> {
        const request = this._apiService.delete<NoContentResponse>(
            endpoints.api.intune.autopilotDevices.delete(id)
        );
        return this._apiService.run<NoContentResponse>(request);
    }
}